<p-messages></p-messages>
<div>
    <p [innerHTML]="config.data?.message"></p>

    <p-floatlabel variant="on">
        <input id="confirmationInput" type="text" pInputText class="input-confirm" [(ngModel)]="confirmationInput" />
        <label for="confirmationInput">Confirmation</label>
    </p-floatlabel>

    <p>
        @if (config.data?.isCreate === true) {
            To confirm creation please enter the following
        } @else {
            To confirm deletion please enter the following
        }
        <p-tag severity="secondary" [rounded]="true" [value]="confirmation"></p-tag>
    </p>
</div>
<div class="p-dialog-footer">
    <p-button icon="pi pi-times" severity="secondary" type="button" label="Cancel" (click)="onCancel()" />
    <p-button
        [severity]="config.data?.isCreate === true ? 'primary' : 'danger'"
        [label]="config.data?.isCreate === true ? 'Create' : 'Delete'"
        [disabled]="confirmation !== confirmationInput"
        (click)="onConfirm()"
        icon="pi pi-check"
    />
</div>
